import { AttachmentSaveLocationType } from './attachment-save-location-type.enum';

export class AttachmentSaveLocationVoModel {

  attachmentFileUuid: string | null = null;
  attachmentSaveLocation: AttachmentSaveLocationType | null = null;

}
